module.exports = __webpack_public_path__ + "media/stylesheets/images/lectures/thumbnail_pencil-f2d7c14664a022a6333f83f4b9e21bcb.jpg";